import NotComparedRow from "./NotComparedRow";

export default NotComparedRow;
